/* unplugin-vue-components disabled */import { render } from "./SlangoNews.vue?vue&type=template&id=50d5702c"
import script from "./SlangoNews.vue?vue&type=script&lang=js"
export * from "./SlangoNews.vue?vue&type=script&lang=js"

import "./SlangoNews.vue?vue&type=style&index=0&id=50d5702c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__